import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import storiesService from '../../services/stories';

const initialState = {
  loading: false,
  storeis: [],
  error: '',
  params: {
    page: 1,
    perPage: 10,
  },
  meta: {},
};

export const fetchStoreis = createAsyncThunk(
  'story/fetchStoreis',
  (params = {}) => {
    return storiesService
      .getAll({ ...initialState.params, ...params })
      .then((res) => res);
  }
);

export const fetchAdminStoreis = createAsyncThunk(
  'story/fetchAdminStoreis',
  (params = {}) => {
    return storiesService
      .getPaginate({ ...initialState.params, ...params })
      .then((res) => res);
  }
);

export const createStory = createAsyncThunk(
  'story/createStory',
  (payload, { rejectWithValue }) => {
    return storiesService
      .upload(payload)
      .then((res) => res)
      .catch((err) => rejectWithValue(err?.response?.data || err?.message));
  }
);

export const deleteStory = createAsyncThunk(
  'story/deleteStory',
  ({ ids }, { rejectWithValue }) => {
    return storiesService
      .delete({ ids })
      .then((res) => res)
      .catch((err) => rejectWithValue(err?.response?.data || err?.message));
  }
);

export const setActiveStory = createAsyncThunk(
  'story/setActiveStory',
  (id, { rejectWithValue }) => {
    return storiesService
      .setActive(id)
      .then((res) => res)
      .catch((err) => rejectWithValue(err?.response?.data || err?.message));
  }
);

export const updateStory = createAsyncThunk(
  'story/updateStory',
  ({ id, body }, { rejectWithValue }) => {
    return storiesService
      .update(id, body)
      .then((res) => res)
      .catch((err) => rejectWithValue(err?.response?.data || err?.message));
  }
);

const storeisSlice = createSlice({
  name: 'storeis',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchAdminStoreis.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchAdminStoreis.fulfilled, (state, action) => {
      const { payload } = action;
      const meta = payload.meta ?? {};
      state.loading = false;
      state.storeis = payload.data ?? [];
      state.meta = meta;
      state.params.page = meta.current_page ?? 1;
      state.params.perPage = meta.per_page ?? 10;
      state.error = '';
    });
    builder.addCase(fetchAdminStoreis.rejected, (state, action) => {
      state.loading = false;
      state.storeis = [];
      state.error = action.error.message;
    });

    builder.addCase(fetchStoreis.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchStoreis.fulfilled, (state, action) => {
      const { payload } = action;
      const meta = payload.meta ?? {};
      state.loading = false;
      state.storeis = payload.data ?? [];
      state.meta = meta;
      state.params.page = meta.current_page ?? 1;
      state.params.perPage = meta.per_page ?? 10;
      state.error = '';
    });
    builder.addCase(fetchStoreis.rejected, (state, action) => {
      state.loading = false;
      state.storeis = [];
      state.error = action.error.message;
    });

    builder.addCase(createStory.fulfilled, (state) => {
      state.error = '';
    });
    builder.addCase(createStory.rejected, (state, action) => {
      state.error = action.payload || action.error?.message || '';
    });

    builder.addCase(deleteStory.fulfilled, (state) => {
      state.error = '';
    });
    builder.addCase(deleteStory.rejected, (state, action) => {
      state.error = action.payload || action.error?.message || '';
    });

    builder.addCase(setActiveStory.fulfilled, (state) => {
      state.error = '';
    });
    builder.addCase(setActiveStory.rejected, (state, action) => {
      state.error = action.payload || action.error?.message || '';
    });

    builder.addCase(updateStory.fulfilled, (state) => {
      state.error = '';
    });
    builder.addCase(updateStory.rejected, (state, action) => {
      state.error = action.payload || action.error?.message || '';
    });
  },
});

export default storeisSlice.reducer;
